import { Component, OnInit, TemplateRef, Input, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageObserveObservationService } from '../ph-bhp-feature-package-observe-observation.service';
import { asepticProcedures } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-asepticprocedures.service';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-feature-package-evaluation.service';
import { AppConfig } from 'src/app/app.config';
import { Console } from 'console';
import { ignoreElements } from 'rxjs-compat/operator/ignoreElements';
import { ICommentTag } from '../Models/ICommentTag'
import { TranslationKeys } from 'ph-bhp-localization';
import { ObservationService } from 'src/app/services/observation.service';

@Component({
  selector: 'lib-ph-bhp-observation-moments',
  templateUrl: './ph-bhp-observation-moments.component.html',
  styleUrls: ['./ph-bhp-observation-moments.component.css']
})

export class PhBhpObservationMomentsComponent implements OnInit {
  @Input() observeRightTab;
  actions: any = [
    { name: "OBSERVATION.HANDWASH", img: "assets/ph-bhp-observeobservation/svg/icon-handwash.svg", activeimg: "assets/ph-bhp-observeobservation/svg/active-icon-handwash.svg" },
    { name: "OBSERVATION.HANDRUB", img: "assets/ph-bhp-observeobservation/svg/icon-handrub.svg", activeimg: "assets/ph-bhp-observeobservation/svg/active-icon-handrub.svg" },
    { name: "OBSERVATION.MISSED", img: "assets/ph-bhp-observeobservation/svg/icon-missed.svg", activeimg: "assets/ph-bhp-observeobservation/svg/active-icon-missed.svg" },
    { name: "OBSERVATION.GLOVES", img: "assets/ph-bhp-observeobservation/svg/icon-gloves.svg", activeimg: "assets/ph-bhp-observeobservation/svg/active-icon-gloves.svg" },
    { name: "OBSERVATION.UNAVAILABLE", img: "assets/ph-bhp-observeobservation/svg/icon-unavailable.svg", activeimg: "assets/ph-bhp-observeobservation/svg/active-icon-unavailable.svg" }
  ]

  tagComments: Array<ICommentTag> = []

  fivemoments: any = [
    { name: TranslationKeys.Observation.BeforeTouching, img: "assets/ph-bhp-observeobservation/svg/icon-bef-t.p..svg", activeimg: "assets/ph-bhp-observeobservation/svg/active-icon-bef-t.p..svg" },
    { name: TranslationKeys.Observation.BeforeAseptic, img: "assets/ph-bhp-observeobservation/svg/icon-bef-aseptic.svg", activeimg: "assets/ph-bhp-observeobservation/svg/active-icon-bef-aseptic.svg" },
    { name: TranslationKeys.Observation.AfterBodyFluidExposure, img: "assets/ph-bhp-observeobservation/svg/icon-aft-body.f.e..svg", activeimg: "assets/ph-bhp-observeobservation/svg/active-icon-aft-body.f.e..svg" },
    { name: TranslationKeys.Observation.AfterTouchingAPatient, img: "assets/ph-bhp-observeobservation/svg/icon-aft-t.p..svg", activeimg: "assets/ph-bhp-observeobservation/svg/active-icon-aft-t.p..svg" },
    { name: TranslationKeys.Observation.AfterTouchingPatientSurroundings, img: "assets/ph-bhp-observeobservation/svg/icon-aft-t.p.s..svg", activeimg: "assets/ph-bhp-observeobservation/svg/active-icon-aft-t.p.s..svg" }
  ]

  asepticprocedures = asepticProcedures;
  asepticprocedureName = '';

  activemoments: Object = {};
  modalRef3: BsModalRef;
  activeIndex: Object = {};
  userComment
  selectedmoment = {};
  selectedaction
  isObserveSaved
  momentsList: any = [];
  momentsArray: any = [];
  observeCount
  currentIndex
  saveInProgress = false;

  asepticActionId = 0;
  selectedAsepticvalue

  @Input() category
  @Input() subcategory
  @Input() count
  @Input() wardID;
  @Input() quotaId;
  @Input() departmentID;
  @Input() departmentTypeID;
  @Input() sessionName
  @Input() createdBy: any
  @Input() sessionActive
  @Input() updatesession
  @Input() currentDate
  @Input() handWashingEnabled
  @Input() showProfessionalSubcategory
  @Input() showAseptictasks
  @Input() observedCount
  @Input() iswebKessConnectionEstablished: boolean;
  @Input() enableHandKissSurveillance: boolean;

  @Input() complianceInstitutionData: {
    isHandwashCompliance: boolean,
    isHandwashHandrubCompliance: boolean
  };

  @Input() categories: any = [];
  @Input() subcategories: any = [];

  // @Output() childData = new EventEmitter();
  @Output() newchildData = new EventEmitter();
  @Output() goBackEmitter = new EventEmitter();
  @Output() finishEdit = new EventEmitter();

  beforeTouchingPatient: boolean = false;
  beforeAsepticProcdures: boolean = false;
  afterBodyFluidExposure: boolean = false;
  afterTouchingPatient: boolean = false;
  afterTouchingPatientSurroundings: boolean = false;
  handRub: boolean = false;
  handWash: boolean = false;
  missed: boolean = false;
  gloves: boolean = false;
  checkvalue: boolean = true;
  enableGloves: boolean = false;
  enableUnavailable: boolean = false;
  unavailable: boolean = false;
  opencancelModal: boolean = false;
  asepticValue: boolean = false;
  exportedToCleanHandCampaignDateTime
  migratedDateTime
  createdDateTime
  createdobservationDateTime
  selectedSubcategories: any = [];
  predefinedComment: any;

  modes = {
    new: 'SOP_OBSERVATION.NEW_OBSERVATION',
    view: 'SOP_OBSERVATION.VIEW_OBSERVATION',
    edit: 'SOP_OBSERVATION.EDIT_OBSERVATION'
  }
  mode = 'new';

  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(
    private modalService: BsModalService,
    private layoutService: PHBHPLayoutPackageService,
    private service: PHBHPFeaturePackageObserveObservationService,
    private evaluationService: PHBHPFeaturePackageEvaluationService,
    public config: AppConfig,
    public observationService: ObservationService,
  ) { }

  ngOnInit() {

    this.momentsList.push({ category: this.category, subcategory: this.subcategory, count: this.count })
    this.setComments();
    this.observationService.resetForm.subscribe(_ => {
      this.resetForm();
    });
    this.observationService.editForm.subscribe(value => {

      if (this.observationService.enableView) {
        this.mode = 'view';
      } else if (this.observationService.enableEdit) {
        this.mode = 'edit';
      } else {
        this.mode = 'new';
      }

      let category = this.categories.find(c => c.categoryID == value.professsionalCategoryID);
      this.tappedCategory(category || {}, true);
      if (this.showProfessionalSubcategory) {
        let subcategory = this.subcategories.find(c => c.subCategoryID == value.professionalSubCategoryID);
        this.tappedSubCategory(subcategory || {}, true);
      }
      this.enableGloves = value.gloves;
      this.enableUnavailable = value.unavailable;
      this.beforeTouchingPatient = value.beforeTouchingPatient;
      this.beforeAsepticProcdures = value.beforeAsepticProcdures;
      this.afterBodyFluidExposure = value.afterBodyFluidExposure;
      this.afterTouchingPatient = value.afterTouchingPatient;
      this.afterTouchingPatientSurroundings = value.afterTouchingPatientSurroundings;
      this.handRub = value.handRub;
      this.handWash = value.handWash;
      this.missed = value.missed;
      this.gloves = value.gloves;
      this.unavailable = value.unavailable;

      this.asepticActionId = value.asepticActionId;
      this.activeIndex = {};
      this.activemoments = {};
      this.userComment = value.userComment;
      if (value.predefinedComments && value.predefinedComments.length > 0) {
        value.predefinedComments.forEach(index => {
          this.tagComments[index].isSelected = true;
        });
      } else {
        this.tagComments.forEach(c => c.isSelected = false)
      }
      this.changeAsepticProcedure(this.asepticActionId);


      this.activemoments[0] = this.beforeTouchingPatient;
      this.activemoments[1] = this.beforeAsepticProcdures;
      this.activemoments[2] = this.afterBodyFluidExposure;
      this.activemoments[3] = this.afterTouchingPatient;
      this.activemoments[4] = this.afterTouchingPatientSurroundings;

      this.activeIndex[0] = this.handWash;
      this.activeIndex[1] = this.handRub;
      this.activeIndex[2] = this.missed;
      this.activeIndex[3] = this.gloves;
      this.activeIndex[4] = this.unavailable;
    });
  }

  resetForm() {
    this.activeIndex[0] = false;
    this.activeIndex[1] = false;
    this.activeIndex[2] = false;
    this.activeIndex[3] = false;
    this.enableGloves = false;
    this.enableUnavailable = false;
    // this.activeIndex = {};
    this.activemoments = {};
    this.beforeTouchingPatient = false;
    this.beforeAsepticProcdures = false;
    this.afterBodyFluidExposure = false;
    this.afterTouchingPatient = false;
    this.afterTouchingPatientSurroundings = false;
    this.handRub = false;
    this.handWash = false;
    this.missed = false;
    this.gloves = false;
    this.unavailable = false;
    // this.updatesession = false;
    this.selectedAsepticvalue = 0;
    this.asepticActionId = 0;
    this.asepticprocedureName = '';
    this.userComment = "";
    this.tagComments.forEach(tag => tag.isSelected = false)
    const checkboxes = document.getElementsByClassName('action-checkbox');
    Array.from(checkboxes).forEach((checkbox: HTMLInputElement) => {
      checkbox.checked = false;
    });
    this.observationService.enableEdit = false;
    this.observationService.editID = 0;
    this.mode = 'new';

    this.finishEdit.emit();
  }

  private setComments() {
    this.tagComments = []
    let userData: any = this.config.userData;

    this.evaluationService.getInstitutionGroupIdById(this.layoutService.institutionID).subscribe((groupId) => {
      var institutionGroupId = "0"
      if (groupId != 0) {
        institutionGroupId = `${groupId},${this.layoutService.institutionID}`;
      }

      this.evaluationService.getPredefinedCommentsForObservation(userData.country, institutionGroupId, this.layoutService.institutionID).subscribe((predefinedComments) => {
        predefinedComments.forEach(predefinedComment => {
          switch (predefinedComment.commentName) {
            case 'jewellery / wrist watch':
              predefinedComment.commentName = this.layoutService.translateText('SOP_OBSERVATION.JEWELLERY_OR_WRIST_WATCH');
              break;
            case 'artificial finger nails / nail varnish':
              predefinedComment.commentName = this.layoutService.translateText('SOP_OBSERVATION.ARTIFICIAL_NAILS_OR_VARNISH');
              break;
            case 'Hand disinfection executed incorrectly':
              predefinedComment.commentName = this.layoutService.translateText('SOP_OBSERVATION.HAND_DISINFECTION_WRONG_EXECUTED');
              break;
            case 'Skin antisepsis executed incorrectly':
              predefinedComment.commentName = this.layoutService.translateText('SOP_OBSERVATION.SKIN_ANTISEPSIS_WRONG_EXECUTED');
              break;
            case 'Process interrupted':
              predefinedComment.commentName = this.layoutService.translateText('SOP_OBSERVATION.PROCESS_INTERRUPTED');
              break;
          }

          if (predefinedComment.packages?.includes("2"))
            this.tagComments = this.tagComments.concat({
              comment: predefinedComment.commentName,
              isSelected: false
            });
        });
      });
    });
  }

  momentsActive(index, asepticModal, name, event) {

    event.stopPropagation();
    event.preventDefault();
    if (this.observationService.enableView) return;

    if (!this.enableHandKissSurveillance) {
      this.opencancelModal = false;
      // this.newValue = true
      if (!this.activemoments[index]) {
        this.activemoments[index] = true;

        if (name == this.translationKeys.Observation.BeforeTouching) { //Before touching a patient") {
          this.beforeTouchingPatient = true;
        }
        else if (name == this.translationKeys.Observation.AfterTouchingAPatient) { //"After touching a patient") {
          this.afterTouchingPatient = true;
        }
        else if (name == this.translationKeys.Observation.AfterTouchingPatientSurroundings) { //"After touching patient surroundings") {
          this.afterTouchingPatientSurroundings = true;
        }
        else if (name == this.translationKeys.Observation.AfterBodyFluidExposure) { //"After body fluid exposure risk") {
          this.afterBodyFluidExposure = true;
        }
        else if (name == TranslationKeys.Observation.BeforeAseptic) { //"Before aseptic procedures") {
          this.beforeAsepticProcdures = true;
        }
      }
      else {
        this.activemoments[index] = false;

        if (name == this.translationKeys.Observation.BeforeTouching) { //"Before touching a patient") {
          this.beforeTouchingPatient = false;
        }
        else if (name == this.translationKeys.Observation.AfterTouchingAPatient) { //"After touching a patient") {
          this.afterTouchingPatient = false;
        }
        else if (name == this.translationKeys.Observation.AfterTouchingPatientSurroundings) { //"After touching patient surroundings") {
          this.afterTouchingPatientSurroundings = false;
        }
        else if (name == this.translationKeys.Observation.AfterBodyFluidExposure) { //"After body fluid exposure risk") {
          this.afterBodyFluidExposure = false;
        }
        else if (name == this.translationKeys.Observation.BeforeAseptic) { //"Before aseptic procedures") {
          this.beforeAsepticProcdures = false;
        }
      }
    }
    else {

      if (this.activemoments[index] == true) {

        switch (index) {
          case 0:
            this.beforeTouchingPatient = false;
            break;
          case 1:
            this.beforeAsepticProcdures = false;
            this.asepticprocedureName = ''
            break;
          case 2:
            this.afterBodyFluidExposure = false;
            break;
          case 3:
            this.afterTouchingPatient = false;
            break;
          case 4:
            this.afterTouchingPatientSurroundings = false;
            break;
        }
        this.asepticActionId = 0;
        this.activemoments[index] = false;
        return;
      }
      this.activemoments = {};
      this.beforeTouchingPatient = false;
      this.beforeAsepticProcdures = false;
      this.afterBodyFluidExposure = false;
      this.afterTouchingPatient = false;
      this.afterTouchingPatientSurroundings = false;
      this.activemoments[index] = true;

      if (name == this.translationKeys.Observation.BeforeTouching) { //"Before touching a patient") {
        this.beforeTouchingPatient = true;
      }
      else if (name == this.translationKeys.Observation.AfterTouchingAPatient) { //"After touching a patient") {
        this.afterTouchingPatient = true;
      }
      else if (name == this.translationKeys.Observation.AfterTouchingPatientSurroundings) { //"After touching patient surroundings") {
        this.afterTouchingPatientSurroundings = true;
      }
      else if (name == this.translationKeys.Observation.AfterBodyFluidExposure) { //"After body fluid exposure risk") {
        this.afterBodyFluidExposure = true;
      }
      else if (name == this.translationKeys.Observation.BeforeAseptic) { //"Before aseptic procedures") {
        this.beforeAsepticProcdures = true;
      }
    }
    if (this.showAseptictasks) {
      if (index == 1) {
        if (this.asepticprocedureName != '') {
          this.asepticprocedureName = '';
          this.activemoments[1] = false;
          this.asepticActionId = 0;
          this.beforeAsepticProcdures = false;
        }
        else {
          this.openaspeticModal(asepticModal)
          this.beforeAsepticProcdures = true;
          this.activemoments[1] = true;
          this.asepticValue = false;
        }
      } else if (this.enableHandKissSurveillance) {
        this.asepticprocedureName = '';
        this.activemoments[1] = false;
        this.asepticActionId = 0;
        this.beforeAsepticProcdures = false;
      }
    }

    this.newchildData.emit(false);
  }

  buttonActive(index, event: Event, name) {
    event.stopPropagation();
    event.preventDefault();
    if (name == this.translationKeys.Observation.Gloves && !this.enableGloves) return;
    // Comparar directamente con el string
    if (name == 'OBSERVATION.UNAVAILABLE' && !this.enableUnavailable) return;
    if (this.observationService.enableView) return;

    this.opencancelModal = false;
    this.selectedaction = name;
    if (!this.activeIndex[index]) {
      this.activeIndex[index] = true;

      if (name == this.translationKeys.Observation.Handwash) {
        this.handWash = true;
      }
      else if (name == this.translationKeys.Observation.Handrub) {
        this.handRub = true;
      }
      else if (name == this.translationKeys.Observation.Missed) {
        this.missed = true;
        this.enableGloves = true;
        this.enableUnavailable = true;
      }
      else if (name == this.translationKeys.Observation.Gloves) {
        this.gloves = true;
      }
      else if (name == 'OBSERVATION.UNAVAILABLE') {
        this.unavailable = true;
      }
    }
    else {
      this.activeIndex[index] = false;
      if (name == this.translationKeys.Observation.Handwash) {
        this.handWash = false;
      }
      else if (name == this.translationKeys.Observation.Handrub) {
        this.handRub = false;
      }
      else if (name == this.translationKeys.Observation.Missed) {
        this.missed = false;
        this.enableGloves = false;
        this.enableUnavailable = false;
      }
      else if (name == this.translationKeys.Observation.Gloves) {
        this.gloves = false;
      }
      else if (name == 'OBSERVATION.UNAVAILABLE') {
        this.unavailable = false;
      }
    }

    if (index === 2) {
      var element4 = <HTMLInputElement>document.getElementById("checkbox-2");
      this.activeIndex[3] = false;
      this.activeIndex[4] = false;
      this.activeIndex[0] = false;
      this.activeIndex[1] = false;
      var element = <HTMLInputElement>document.getElementById("checkbox-0");
      element.checked = false;
      this.handWash = false;
      var element1 = <HTMLInputElement>document.getElementById("checkbox-1");
      element1.checked = false;
      this.handRub = false;
      var elementGloves = <HTMLInputElement>document.getElementById("checkbox-3");
      if (elementGloves) elementGloves.checked = false;
      this.gloves = false;
      var elementUnavailable = <HTMLInputElement>document.getElementById("checkbox-4");
      if (elementUnavailable) elementUnavailable.checked = false;
      this.unavailable = false;
    }

    if (index == 1 || index == 0) {
      this.activeIndex[2] = false;
      this.activeIndex[3] = false;
      this.activeIndex[4] = false;
      var element2 = <HTMLInputElement>document.getElementById("checkbox-2");
      element2.checked = false;
      this.missed = false;
      var element3 = <HTMLInputElement>document.getElementById("checkbox-3");
      if (element3) element3.checked = false;
      this.gloves = false;
      var elementUnavailable2 = <HTMLInputElement>document.getElementById("checkbox-4");
      if (elementUnavailable2) elementUnavailable2.checked = false;
      this.unavailable = false;
      this.enableGloves = false;
      this.enableUnavailable = false;
    }

    this.newchildData.emit(false);
  }

  private tappedComment(comment: ICommentTag) {
    if (this.observationService.enableView) return;
    comment.isSelected = !comment.isSelected
  }

  SubmitObservationSession(session) {
    let value: any = {};
    this.checkvalue = true;
    this.observeCount = false;
    this.opencancelModal = true;
    let compliant;
    let completed;

    if (!this.category || !this.category.categoryID) {
      this.layoutService.showError(this.layoutService.translateText(TranslationKeys.ErrorMessages.RequiredProfessionalCategory));
      return;
    } else if (this.showProfessionalSubcategory && (!this.subcategory || !this.subcategory.subCategoryID)) {
      this.layoutService.showError(this.layoutService.translateText(TranslationKeys.ErrorMessages.RequiredProfessionalSubCategory));
      return;
    }

    if ((this.beforeTouchingPatient || this.afterTouchingPatient || this.afterTouchingPatientSurroundings
      || this.afterBodyFluidExposure || this.beforeAsepticProcdures) && (this.handWash || this.handRub || this.missed)) {
      completed = true;
    } else {
      completed = false;
    }

    //HHP-3063
    if (this.missed || this.gloves) {
      compliant = false;
    } else if (!this.complianceInstitutionData.isHandwashCompliance && !this.complianceInstitutionData.isHandwashHandrubCompliance) {
      if (!this.handWash && !this.handRub) {
        compliant = false;
      } else if (!this.handWash && this.handRub) {
        compliant = true;
      } else if (this.handWash && !this.handRub) {
        compliant = false;
      } else if (this.handWash && this.handRub) {
        compliant = false;
      }
    } else if (!this.complianceInstitutionData.isHandwashCompliance && this.complianceInstitutionData.isHandwashHandrubCompliance) {
      if (!this.handWash && !this.handRub) {
        compliant = false;
      } else if (!this.handWash && this.handRub) {
        compliant = true;
      } else if (this.handWash && !this.handRub) {
        compliant = false;
      } else if (this.handWash && this.handRub) {
        compliant = true;
      }
    } else if (this.complianceInstitutionData.isHandwashCompliance && !this.complianceInstitutionData.isHandwashHandrubCompliance) {
      if (!this.handWash && !this.handRub) {
        compliant = false;
      } else if (!this.handWash && this.handRub) {
        compliant = true;
      } else if (this.handWash && !this.handRub) {
        compliant = true;
      } else if (this.handWash && this.handRub) {
        compliant = false;
      }
    } else if (this.complianceInstitutionData.isHandwashCompliance && this.complianceInstitutionData.isHandwashHandrubCompliance) {
      if (!this.handWash && !this.handRub) {
        compliant = false;
      } else if (!this.handWash && this.handRub) {
        compliant = true;
      } else if (this.handWash && !this.handRub) {
        compliant = true;
      } else if (this.handWash && this.handRub) {
        compliant = true;
      }
    }

    if (session == "savesession") {
      this.isObserveSaved = true;
      var observeRequestId = this.generateRandomGuid();
      var createobservation = {
        observationValue: {
          observeObservationID: 0,
          observationSessionID: this.observationService.observationSession.observationSessionID,
          professsionalCategoryID: this.category?.categoryID || null,
          professionalSubCategoryID: this.subcategory?.subCategoryID || null,
          beforeTouchingPatient: this.beforeTouchingPatient,
          beforeAsepticProcdures: this.beforeAsepticProcdures,
          afterBodyFluidExposure: this.afterBodyFluidExposure,
          afterTouchingPatient: this.afterTouchingPatient,
          afterTouchingPatientSurroundings: this.afterTouchingPatientSurroundings,
          handRub: this.handRub,
          handWash: this.handWash,
          missed: this.missed,
          gloves: this.gloves,
          unavailable: this.unavailable,
          asepticActionId: this.asepticActionId,
          compliant: compliant,
          observeComments: this.getSelectedComments(),
          createdBy: this.createdBy,
          createdDateTime: new Date(),
          completed: completed,
          predefinedComments: this.getSelectedCommentsIndex(),
          userComment: this.userComment,
          observeRequestId: observeRequestId,
          saved: true
        }
      }
      this.observationService.observations.push(createobservation.observationValue);
      this.service.createObservation(createobservation.observationValue, this.quotaId).subscribe((res: any) => {
        var responseArray = {
          observationValue: {
          }
        }

        responseArray.observationValue = res;
        this.savedDataArray(responseArray);
      }, error => {
        this.observationService.observations.find(x => x.observeRequestId == observeRequestId).saved = false;
      });
    }
    else if (session == "updatesession") {
      this.isObserveSaved = false;

      var updateObservation = {
        observationValue: {
          observeObservationID: this.observationService.editID,
          observationSessionID: this.observationService.observationSession.observationSessionID,
          professsionalCategoryID: this.category?.categoryID || null,
          professionalSubCategoryID: this.subcategory?.subCategoryID || null,
          beforeTouchingPatient: this.beforeTouchingPatient,
          beforeAsepticProcdures: this.beforeAsepticProcdures,
          afterBodyFluidExposure: this.afterBodyFluidExposure,
          afterTouchingPatient: this.afterTouchingPatient,
          afterTouchingPatientSurroundings: this.afterTouchingPatientSurroundings,
          handRub: this.handRub,
          handWash: this.handWash,
          missed: this.missed,
          gloves: this.gloves,
          unavailable: this.unavailable,
          asepticActionId: this.asepticActionId,
          compliant: compliant,
          observeComments: this.getSelectedComments(),
          createdBy: this.createdBy,
          createdDateTime: this.observationService.editObservation.createdDateTime,
          updatedDateTime: new Date(),
          completed: completed,
          predefinedComments: this.getSelectedCommentsIndex(),
          userComment: this.userComment
        }
      }

      this.service.updateObservation(updateObservation.observationValue, this.observationService.editID).subscribe((res: any) => {
        var responseArray = {
          observationValue: {
          }
        }

        var observation = this.observationService.observations.find(x => x.observeObservationID == res.observeObservationID);
        observation.professionalSubCategoryID = updateObservation.observationValue.professionalSubCategoryID;
        observation.professsionalCategoryID = updateObservation.observationValue.professsionalCategoryID;
        observation.beforeTouchingPatient = updateObservation.observationValue.beforeTouchingPatient;
        observation.beforeAsepticProcdures = updateObservation.observationValue.beforeAsepticProcdures;
        observation.afterBodyFluidExposure = updateObservation.observationValue.afterBodyFluidExposure;
        observation.afterTouchingPatient = updateObservation.observationValue.afterTouchingPatient;
        observation.afterTouchingPatientSurroundings = updateObservation.observationValue.afterTouchingPatientSurroundings;
        observation.handRub = updateObservation.observationValue.handRub;
        observation.handWash = updateObservation.observationValue.handWash;
        observation.missed = updateObservation.observationValue.missed;
        observation.gloves = updateObservation.observationValue.gloves;
        observation.unavailable = updateObservation.observationValue.unavailable;
        observation.asepticActionId = updateObservation.observationValue.asepticActionId;
        observation.compliant = updateObservation.observationValue.compliant;
        observation.observeComments = updateObservation.observationValue.observeComments;
        observation.completed = updateObservation.observationValue.completed;
        observation.predefinedComments = updateObservation.observationValue.predefinedComments;
        observation.userComment = updateObservation.observationValue.userComment;
        responseArray.observationValue = res;
        this.savedDataArray(responseArray);
      }, error => {
        this.layoutService.showError(this.layoutService.translateText("ERROR_MESSAGES.OBSERVATION.ERROR_UPDATING"), this.layoutService.translateText("AUTHORIZATION.ERROR"));
        console.log(error);
      }, () => {
        this.sessionActive = false;
        this.cancelEdit();
      });

    }

    this.observationService.observationsList = this.observationService.observations.slice().reverse();
    this.resetForm();
  }

  public generateRandomGuid() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
      (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
  }

  public cancelEdit() {
    this.observationService.enableView = false;
    this.observationService.enableEdit = false;
    this.observationService.editID = 0;
    this.observationService.editForm.next({});
    delete this.category;
    delete this.subcategory;
    this.categories.forEach(c => c.isSelected = false);
    if (this.showProfessionalSubcategory) {
      this.subcategories.forEach(s => s.isSelected = false);
    }
    return;
  }

  // resteForm() {
  //   this.asepticprocedureName = '';
  //   this.activeIndex = {};
  //   this.activemoments = {};
  //   this.beforeTouchingPatient = false;
  //   this.beforeAsepticProcdures = false;
  //   this.afterBodyFluidExposure = false;
  //   this.afterTouchingPatient = false;
  //   this.afterTouchingPatientSurroundings = false;
  //   this.handRub = false;
  //   this.handWash = false;
  //   this.missed = false;
  //   this.gloves = false;
  //   this.updatesession = false;
  //   this.asepticActionId = 0;
  //   this.userComment = "";
  //   this.tagComments.forEach(c => c.isSelected = false);
  //   this.enableGloves = false;
  //   this.observationService.enableView = false;
  //   this.observationService.enableEdit = false;
  //   this.observationService.editID = 0;

  //   this.finishEdit.emit();
  // }

  getSelectedComments(): string {
    try {
      var selectedComments = this.tagComments
        .filter(c => c.isSelected)
        .map(c => c.comment)
      if (this.userComment)
        selectedComments.push(this.userComment)
      return selectedComments.join('##')
      // return {
      //   userComments: this.userComment,
      //   prefefinedComments: this.tagComments.map(tag => tag.comment)
      // }}
    }
    catch (error) {
      console.log(error)
    }
  }

  getSelectedCommentsIndex() {
    return this.tagComments.map((item, index) => item.isSelected ? index : -1)
      .filter(index => index !== -1);
  }

  goBack() {
    this.goBackEmitter.emit();
  }

  openaspeticModal(asepticModal: TemplateRef<any>) {
    this.modalRef3 = this.modalService.show(asepticModal, Object.assign({}, { class: 'asepticModalContain w-auto', backdrop: false, ignoreBackdropClick: true, keyboard: false }))
  }

  getAscepticProceturevalue(value) {
    if (value == 'deselect') {
      this.asepticprocedureName = '';
      this.activemoments[1] = false;
      this.asepticActionId = 0;
      this.beforeAsepticProcdures = false;
    } else if (value == 'close' && this.asepticprocedureName == '') {
      this.activemoments[1] = false;
      this.beforeAsepticProcdures = false;
      this.asepticActionId = 0;
    } else if (value == 'close' && this.asepticprocedureName != '') {
      this.activemoments[1] = true;
    }
    this.modalRef3.hide();
  }

  changeAsepticProcedure(asepticActionId) {
    if (asepticActionId > 0) {
      this.asepticprocedureName = this.asepticprocedures[asepticActionId - 1].value;
    } else {
      this.asepticprocedureName = '';
    }
  }

  savedDataArray(value) {
    let observation = this.observationService.observations.find(x => x.observeObservationID == 0 || x.observeObservationID == value.observationValue.observeObservationID || x.observeRequestId == value.observationValue.observeRequestId);
    // for not loss the ref of the object.
    observation.observeObservationID = value.observationValue.observeObservationID;
    observation.observationSessionID = this.observationService.observationSession.observationSessionID;
    observation.afterBodyFluidExposure = value.observationValue.afterBodyFluidExposure;
    observation.afterTouchingPatient = value.observationValue.afterTouchingPatient;
    observation.afterTouchingPatientSurroundings = value.observationValue.afterTouchingPatientSurroundings;
    observation.asepticActionId = value.observationValue.asepticActionId;
    observation.beforeAsepticProcdures = value.observationValue.beforeAsepticProcdures;
    observation.beforeTouchingPatient = value.observationValue.beforeTouchingPatient;
    observation.compliant = value.observationValue.compliant;
    observation.gloves = value.observationValue.gloves;
    observation.handRub = value.observationValue.handRub;
    observation.handWash = value.observationValue.handWash;
    observation.missed = value.observationValue.missed;
    observation.observeComments = value.observationValue.observeComments;
    observation.updatedDateTime = value.observationValue.updatedDateTime;
    observation.createdDateTime = value.observationValue.createdDateTime;
    observation.professsionalCategoryID = value.observationValue.professsionalCategoryID;
    observation.professionalSubCategoryID = value.observationValue.professionalSubCategoryID;
    observation.completed = value.observationValue.completed;
    observation.compliant = value.observationValue.compliant;
    observation.observationSessionID = value.observationValue.observationSessionID;
    // observation.predefinedComments = this.getSelectedCommentsIndex();
    // observation.userComment = this.userComment;
    this.observationService.observationSession.endDateTime = value.observationValue.createdDateTime;
    this.saveInProgress = false;
    if (this.quotaId > 0) {
      this.service.getObservationQuotaCount(this.quotaId).subscribe((res: any) => {
        this.observationService.observedQuotaCount = res;
      });
    }
  }

  tappedCategory(category, tapped?) {

    if (!tapped && this.observationService.enableView) return;

    this.category = category;
    delete this.subcategory;
    this.categories.forEach(c => { if (c.categoryID != category.categoryID) c.isSelected = false })
    category.isSelected = tapped || !category.isSelected;
    if (this.showProfessionalSubcategory) {
      this.subcategories.forEach(s => { s.isSelected = false })
    }
    if (!category.isSelected) {
      delete this.category;
      this.selectedSubcategories = [];
    } else if (this.showProfessionalSubcategory) {
      this.selectedSubcategories = this.subcategories.filter(s => s.categoryID == category.categoryID);
      let lastCategory = [...this.observationService.observations].reverse().find(c => c.professsionalCategoryID == this.category.categoryID);
      if (lastCategory) {
        this.subcategory = this.subcategories.find(s => s.subCategoryID == lastCategory.professionalSubCategoryID);
        this.subcategories.forEach(s => { if (s.subCategoryID != this.subcategory.subCategoryID) s.isSelected = false })
        this.subcategory.isSelected = true;
      }
    }
  }

  tappedSubCategory(subcategory, tapped?) {
    if (!tapped && this.observationService.enableView) return;

    this.subcategory = subcategory;
    this.subcategories.forEach(s => { if (s.subCategoryID != subcategory.subCategoryID) s.isSelected = false })
    subcategory.isSelected = tapped || !subcategory.isSelected;
    if (!subcategory.isSelected) {
      delete this.subcategory;
    }
  }

  public nextIsDisabled() {

    if (!this.category) {
      return true;
    } else if (this.category && this.showProfessionalSubcategory && !this.subcategory) {
      return true;
    } else {
      false;
    }
  }

  public checkObservationInProgress() {
    // check if the current observation is in progress, category and subcategory selected, moment and action, and/or any comment
    if (this.category && (this.showProfessionalSubcategory ? this.subcategory : true)
      && (this.beforeTouchingPatient || this.afterTouchingPatient || this.afterTouchingPatientSurroundings || this.afterBodyFluidExposure || this.beforeAsepticProcdures
        || (this.userComment || this.tagComments.filter(tag => tag.isSelected).length > 0))) {
      this.saveInProgress = true;
      // if the observation in progress is not completed, keep the selection on the screen 
      let completed;
      if ((this.beforeTouchingPatient || this.afterTouchingPatient || this.afterTouchingPatientSurroundings
        || this.afterBodyFluidExposure || this.beforeAsepticProcdures) && (this.handWash || this.handRub || this.missed)) {
        completed = true;
      } else {
        completed = false;
      }
      this.SubmitObservationSession('savesession');
    }
  }

  onCommentsKeyDown(event) {
    if (!(event.keyCode >= 48 && event.keyCode <= 57) && !(event.keyCode >= 65 && event.keyCode <= 90) && !(event.keyCode >= 96 && event.keyCode <= 105)) return;
    if (this.userComment && this.userComment.length >= 500) {
      this.layoutService.showWarning(this.layoutService.translateText('OBSERVATION.MAXIMUM_COMMENT_LENGTH'));
    }
  }
}
